import React from 'react';
import { useTranslation } from 'react-i18next';
import { nsoncustomer } from "../../../../i18n/namespaces";
export const ParameterMultiContainerDefault = props => {
  const {
    parameterName,
    showAddDeleteButtons = true,
    onInsert,
    onDelete,
    children
  } = props;
  const {
    t
  } = useTranslation(nsoncustomer.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, parameterName && /*#__PURE__*/React.createElement("div", {
    className: "parameter-item-container mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("label", {
    className: "g-0 col-auto"
  }, parameterName), showAddDeleteButtons && /*#__PURE__*/React.createElement("div", {
    className: "col-auto text-primary"
  }, /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer text-decoration-underline",
    onClick: onInsert
  }, t('core.parameter.addMultiparameter')), /*#__PURE__*/React.createElement("span", {
    className: "mx-1"
  }, "|"), /*#__PURE__*/React.createElement("a", {
    className: "cursor-pointer text-decoration-underline",
    onClick: onDelete
  }, t('core.parameter.removeMultiparameter'))))), /*#__PURE__*/React.createElement("div", {
    className: "multiparameter-item-container ps-4 mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "parameter-group-item-fields"
  }, children)));
};